import { createUseStyles } from "react-jss";
import { colors } from "constants/colors";

const styles = createUseStyles((theme) => ({
  discountsPage: {
    marginBottom: "32px",
  },
  headerContainer: {
    maxWidth: "100%",
  },
  headerTitle: {
    color: colors.lightBlack,
    fontWeight: "600",
    fontSize: "30px",
    lineHeight: "38px",
    padding: "0px",
    margin: "0px",
  },
  headerSubtitle: {
    color: colors.mediumGrey,
    fontWeight: "400",
    fontSize: "16px",
    lineHeight: "24px",
    padding: "0px",
    marginTop: "4px",
    marginBottom: "32px",
  },
}));

export default styles;
